import InfoCard from '@/components/InfoCard'

export default {
  name: 'ShowcaseItem',
  components: {
    InfoCard
  },
  props: [
    'item',
    'isDropdown'
  ],
  data() {
    return {
      isExpanded: false
    }
  },
  methods: {
    toggleVisibility() {
      this.$emit('toggle-expand', this.item)
    },
    itemClick() {
      this.item.showcase === 'resume' ? this.toggleVisibility() : this.redirectWorkItem()
    },
    redirectWorkItem() {
      console.log(this.item.name)
      this.$router.push(`/Project/${this.item.name}`)
    }
  },
  mounted() {
    let titles = document.querySelectorAll(".notDropdownTitle")
    titles.forEach(title => {
      title.style.width = title.offsetWidth + '4.5rem'
    })
  }
}